import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import StudentsMenu from "./students_menu";
import { useAcademicPartWithFormByStudentFormGroupedByTerm } from "../../../../../_hooks/academic_part/useAcademicPartWithFormByStudentFormGroupedByTerm.hook";
import TotalTermInfo from "./total_term_info";
import { TotalStatus } from "./total_status";

function TotalInfo({ students, studentFormEvaluationsHook }){

    const studentFormEvaluationsHookTotal =  useAcademicPartWithFormByStudentFormGroupedByTerm(studentFormEvaluationsHook.selected ? {...studentFormEvaluationsHook.selected} : '' );

    return(
        <Container fluid>
            <Row>
                <Col lg={2}>
                    <StudentsMenu
                        students={students}
                        selected={studentFormEvaluationsHook.selected.uuid}
                        loadData={(studentForm) => {
                            studentFormEvaluationsHook.setSelected(studentForm);
                            studentFormEvaluationsHookTotal.loadData(studentForm.uuid);
                            //console.log(`ReCargar ${studentForm.uuid}, ${term}`);
                        }}
                    />
                </Col>
                <Col lg={10}>
                    <hr />
                    <Container fluid >
                        <Row>
                            <Col style={{ margin: '20px 0' }} lg={12}>
                                <TotalStatus terms={studentFormEvaluationsHookTotal.data.terms} />
                            </Col>
                        </Row>
                        <Row>
                            {
                                studentFormEvaluationsHookTotal.data.terms.map((d, key) => {
                                    return(                                        
                                        <Col key={`total_${key}`} lg={4}>
                                            <TotalTermInfo
                                                data={d.academic_part}
                                                term={d.term}
                                            />
                                        </Col>
                                    );
                                })
                            }
                        </Row>
                    </Container>            
                </Col>
            </Row>
        </Container>
    );
}

export default TotalInfo;